<template>
    <transition
        enter-active-class="transition ease-out duration-150"
        enter-class="transform opacity-0"
        enter-to-class="transform opacity-100"
        leave-active-class="transition ease-in duration-150"
        leave-class="transform opacity-100"
        leave-to-class="transform opacity-0"
    >
        <div class="absolute inset-0 flex items-center"
            :class="loading ? 'opacity-0' : 'opacity-100'"
            v-show="loading || (current_slide === index)"
        >
            <div class="flex flex-col-reverse md:flex-row items-center md:space-x-12"
                ref="slide"
            >
                <div v-if="image"
                    class="w-1/2 md:w-1/4 flex-none pt-6 md:pt-0"
                >
                    <img class="w-full rounded-md"
                        :src="image"
                    />
                </div>

                <div>
                    <p class="text-gray-200 font-light leading-normal text-base md:text-md tracking-relaxed mb-0"
                        v-html="body"
                    >
                    </p>

                    <p class="text-left text-gray-200 font-light italic text-base tracking-relaxed pt-6 mb-0"
                        v-html="author"
                    >
                    </p>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        author: {},
        body: {},
        image: {},
        index: {},
        current_slide: {},
    },

    data() {
        return {
            loading: true,
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.$emit('heightCalculated', this.$refs.slide.scrollHeight);
            this.loading = false;
        });
    },
}
</script>
